import ForgotPasswordConfirm from './forgot-password-confirm';

export default ForgotPasswordConfirm;
